var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer3", attrs: { id: "footer" } }, [
    !_vm.isEnterPrise
      ? _c("div", { staticClass: "footer-content" }, [
          _c("div", { staticClass: "logo" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "copyright" }, [
              _vm._v(
                "\n\t\t\t\t© " +
                  _vm._s(_vm.getConstants("YEAR")) +
                  "\n\t\t\t\t" +
                  _vm._s(_vm.getConstants("SHANGHAI_YIJING")) +
                  "\n\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", { staticClass: "page-locale-para" }, [
              _c(
                "span",
                {
                  staticClass: "locale-item",
                  on: {
                    click: function($event) {
                      return _vm.setPageLocaleCookie("zh_CN")
                    }
                  }
                },
                [_vm._v("中文")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "locale-item",
                  on: {
                    click: function($event) {
                      return _vm.setPageLocaleCookie("en")
                    }
                  }
                },
                [_vm._v("English")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "locale-item",
                  on: {
                    click: function($event) {
                      return _vm.setPageLocaleCookie()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.getConstants("AUTO")))]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "links" },
            [
              _c("div", { staticClass: "link-list" }, [
                _c("ul", [
                  _c("li", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.getConstants("NUTSTORE")))
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c(
                      "a",
                      { attrs: { href: "/s/pricing", target: "_blank" } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.getConstants("INDIVIDUAL_EDITION_FOR_SHORT")
                          )
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c("a", { attrs: { href: "/s/team", target: "_blank" } }, [
                      _vm._v(_vm._s(_vm.getConstants("TEAM_EDITION_FOR_SHORT")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c(
                      "a",
                      { attrs: { href: "/s/enterprise", target: "_blank" } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.getConstants("ENTERPRISE_EDITION_FOR_SHORT")
                          )
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c(
                      "a",
                      { attrs: { href: "/s/downloads", target: "_blank" } },
                      [
                        _vm._v(
                          _vm._s(_vm.getConstants("DOWNLOAD_CLIENTS_FOR_SHORT"))
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "http://help.jianguoyun.com/?page_id=843",
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.getConstants("FEATURES")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "http://help.jianguoyun.com/?page_id=3961",
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.getConstants("PRIVACY_STATEMENT")))]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "link-list" }, [
                _c("ul", [
                  _c("li", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.getConstants("RESOURCER_COMMUNITY")))
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "/d/applyTeamFreeTrial",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.getConstants("ENTERPRISE_APPLY_TRIAL"))
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "http://www.jianguoyun.com/s/content/",
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.getConstants("APP_GALAXY")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c(
                      "a",
                      { attrs: { href: "/s/pricing", target: "_blank" } },
                      [_vm._v(_vm._s(_vm.getConstants("SERVICE_PRICE")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "http://help.jianguoyun.com/",
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.getConstants("HELP_CENTER")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c(
                      "a",
                      { attrs: { href: "/s/tutorial", target: "_blank" } },
                      [_vm._v(_vm._s(_vm.getConstants("VIDEO_TUTORIAL")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "http://blog.jianguoyun.com/",
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.getConstants("BLOG")))]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("hot-link"),
              _vm._v(" "),
              _c("div", { staticClass: "link-list" }, [
                _c("ul", [
                  _c("li", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.getConstants("MANAGEMENT_SUPPORT")))
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.jianguoyun.com/s/helpdesk",
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.getConstants("ONLINE_SUPPORT")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c(
                      "a",
                      { attrs: { href: "/s/contactus", target: "_blank" } },
                      [_vm._v(_vm._s(_vm.getConstants("CONTACT_US")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "link" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "/static/html/joinus/index.html",
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.getConstants("JOIN_US2")))]
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "QRcode" }, [
            _c("p", [_vm._v(_vm._s(_vm.getConstants("CONTENT_WECHAT")))]),
            _vm._v(" "),
            _c("img", {
              attrs: { src: "/static/images/wechat_barcode.png", alt: "" }
            })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "cert" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("p", [
        _vm._m(2),
        _vm._v(" "),
        _c("span", [
          _c(
            "a",
            {
              attrs: {
                rel: "nofollow",
                target: "_blank",
                href:
                  "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502003377"
              }
            },
            [_vm._v(_vm._s(_vm.getConstants("POLICE_RECORD")))]
          )
        ]),
        _vm._v(" "),
        _c("span", [
          _c(
            "a",
            {
              attrs: {
                rel: "nofollow",
                target: "_blank",
                href: "https://beian.miit.gov.cn"
              }
            },
            [_vm._v(_vm._s(_vm.getConstants("ICP_RECORD")))]
          )
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("增值电信业务经营许可证：B1-20193672")]),
        _vm._v(" "),
        _vm._m(3)
      ]),
      _vm._v(" "),
      _vm._m(4)
    ]),
    _vm._v(" "),
    _vm.isEnterPrise
      ? _c("div", { staticClass: "is_enterprise_instance" }, [
          _c(
            "div",
            { staticStyle: { margin: "0 auto", "text-align": "center" } },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "margin-left": "10px",
                    color: "#000",
                    opacity: ".5",
                    filter: "alpha(opacity=50)"
                  },
                  on: {
                    click: function($event) {
                      return _vm.setPageLocaleCookie("zh_CN")
                    }
                  }
                },
                [_vm._v("中文")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    "margin-left": "10px",
                    color: "#000",
                    opacity: ".5",
                    filter: "alpha(opacity=50)"
                  },
                  on: {
                    click: function($event) {
                      return _vm.setPageLocaleCookie("en")
                    }
                  }
                },
                [_vm._v("English")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    "margin-left": "10px",
                    color: "#000",
                    opacity: ".5",
                    filter: "alpha(opacity=50)"
                  },
                  on: {
                    click: function($event) {
                      return _vm.setPageLocaleCookie()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.getConstants("AUTO")))]
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-nutstore" }, [
      _c("img", {
        staticClass: "footerLogo",
        attrs: {
          border: "0",
          src: "/static/images/large@2x.png",
          alt: "Nutstore"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", [_vm._v("开发者名称：上海亦净网络科技有限公司")]),
      _vm._v(" "),
      _c("span", [_vm._v("版本：4.23.1")]),
      _vm._v(" "),
      _c("span", [
        _c(
          "a",
          {
            attrs: {
              rel: "nofollow",
              target: "_blank",
              href: "http://help.jianguoyun.com/?page_id=3961"
            }
          },
          [_vm._v("隐私协议")]
        )
      ]),
      _vm._v(" "),
      _c("span", [
        _c(
          "a",
          {
            attrs: {
              rel: "nofollow",
              target: "_blank",
              href: "https://help.jianguoyun.com/?p=5972"
            }
          },
          [_vm._v("用户权限")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "iso" }, [
      _c(
        "a",
        {
          attrs: {
            rel: "nofollow",
            target: "_blank",
            href: "/static/images/ISO.jpg"
          }
        },
        [_vm._v("ISO27001认证")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c(
        "a",
        {
          attrs: {
            rel: "nofollow",
            target: "_blank",
            href: "/static/images/IST.jpg"
          }
        },
        [_vm._v("等保三级")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", [_vm._v("违法和不良信息举报电话：021-50782360")]),
      _vm._v(" "),
      _c("span", [
        _c(
          "a",
          {
            attrs: {
              rel: "nofollow",
              target: "_blank",
              href: "https://www.12377.cn"
            }
          },
          [_vm._v("网上有害信息举报专区")]
        )
      ]),
      _vm._v(" "),
      _c("span", [
        _c("a", {
          staticClass: "shjbzx",
          attrs: {
            rel: "nofollow",
            target: "_blank",
            href: "http://www.shjbzx.cn/"
          }
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }